import {
  Box, Button, SidebarModal,
  SquareIconWithBackground,
} from '@domain-group/suit-theme'

import type { SidebarModalProps } from '@domain-group/suit-theme'
import { faFileCirclePlus, faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import CopyFromTemplate from './CopyFromTemplate'

const MODAL_KEY = 'BulkPermissionsModal'

type BulkPermissionsModalProps = {
  callbacks: {

  },
  selectedTemplateIds: number[],
  showModal: boolean,
}

const BulkPermissionsModal = (props: SidebarModalProps & BulkPermissionsModalProps) => {
  const { callbacks, selectedTemplateIds, showModal } = props

  const [page, setPage] = useState<'copy' | null>(null)

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Assign" titleSecondLine="Permissions" />

      <SidebarModal.Content>
        <Box flexDirection="column">
          {page === null && (
            <>
              <SidebarModal.Button
                iconLeft={
                  <SquareIconWithBackground icon={<FontAwesomeIcon icon={faMagnifyingGlass} />} />
                }
                showAngleIcon
                subtitle="Assign permissions manually"
                title="Assign Manually"
              />
              <SidebarModal.Button 
                iconLeft={
                  <SquareIconWithBackground icon={<FontAwesomeIcon icon={faFileCirclePlus} />} />
                }
                showAngleIcon
                subtitle="Copy permissions from a template"
                title="Copy from a Template"
                onClick={() => setPage('copy')}
              />
            </>
          )}

          {page === 'copy' && (
            <CopyFromTemplate callbacks={callbacks} selectedTemplateIds={selectedTemplateIds} />
          )
          }
        </Box>
      </SidebarModal.Content>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: SidebarModalProps & BulkPermissionsModalProps) => (
  <SidebarModal.RenderController {...props}>
    <BulkPermissionsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
